<div id="content-desktop">
  <header>


    <div class="container">
      <br />
      <div class="row">
        <div class="col-md-12">
          <span style="padding-top: 1%; padding-bottom: 1%; width: 10% " class="img-responsive">
            <img src="../../../assets/D URL 2.png" style="width: 40%; position: absolute; top: 25%; " class="img-responsive" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="../../../assets/D Beef Phone.png" style="width: 15%; display: block; margin-left: auto; top: 50%;" class="right" />
          </span>
        </div>
      </div>
    </div>
    <br />
    <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #d64038 ">
      <div class="container">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
          <ul class="navbar-nav flex-grow">
            <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
              <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Home</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold">Notice/FAQs</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">File A Claim</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Court Documents</a>
            </li>
            <li class="nav-item" [routerLinkActive]="['link-active']">
              <a class="nav-link hover_lightBlue" [routerLink]="['/contact-information']" style="color:white; font-weight: bold ">Contact Information</a>
            </li>
          </ul>
        </div>
      </div>

    </nav>


  </header>
</div>


<div class="container" style="border:1px solid #bebaba">
  <br />
  <h3><b>Long Form Notice / FAQ's</b></h3>
  <br />
  <b>
    Notice of Claim Filing - Defendant Tyson
  </b>
  <ul>
    <li>
      <a href="../../../assets/documents/courtdocs/9-8-26 Beef Mtn to Modify Notice and Schedule - Exhibit A (Modified Long Form Notice).docx"
         target="_blank">
        Notice of claim filing
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/9-8-26 Beef Mtn to Modify Notice and Schedule - Exhibit D (Modified Blank Claim Form).docx"
         target="_blank">
        Claim form
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/courtdocs/9-8-26 Beef Mtn to Modify Notice and Schedule - Exhibit F (Modified Audit Request Form).docx"
         target="_blank">
        Audit request form
      </a>
    </li>
  </ul>

  <b>Notice of Claims Filing</b>
  <ul>
    <li>
      <a href="../../../assets/documents/noticedocs/Beef_Long_Form_Notice - Final.pdf"
         target="_blank">
        Notice of claim filing
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/noticedocs/Beef_Blank_Claim_Form - Final.pdf"
         target="_blank">
        Claim form
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/noticedocs/Beef Audit Request Form - Final.pdf"
         target="_blank">
        Audit request form
      </a>
    </li>
  </ul>

  <b>Notice of Settlement</b>
  <ul>
    <li>
      <a href="../../../assets/documents/noticedocs/Beef Long Form Final- 5-3-22 correction.pdf"
         target="_blank">
        Notice of claim filing
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/noticedocs/Beef Short Form Final-5-3-22 correction.pdf"
         target="_blank">
        Claim form
      </a>
    </li>
    <li>
      <a href="../../../assets/documents/noticedocs/Beef Audit Request Form - Final.pdf"
         target="_blank">
        Audit request form
      </a>
    </li>
  </ul>

  <b>La Nota</b>
  <ul>
    <li>
      <a href="../../../assets/documents/noticedocs/Beef Long Form Final_Spanish.pdf"
         target="_blank">
        Aviso
      </a>
    </li>
  </ul>
</div>








